module.exports = __webpack_public_path__ + "static/media/volume_mute_actived.7f8eb827.svg";